import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class StorageRegister {
  // 存储登记列表
  static getStorageRegisterList(options) {
    let url = '/zwy/api/cb/logistics/rent/order/stock/batch/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 需要登记的进仓单列表
  static getStorageRegisterEntryExitCodeList(options) {
    let url = '/zwy/api/cb/logistics/rent/order/need/calculate/inbound/order/list?'
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 登记
  static postSaveStorageRegister(data) {
    const url = '/zwy/api/cb/logistics/rent/order/calculate/rent/fee'
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  } 
  // 存储登记详情
  static getStorageRegisterDetails(id) {
    const url = `/zwy/api/cb/logistics/rent/order/stock/batch/detail/${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }

  // 导出
  static getExportExcel(projectId, balanceMonth) {
    const url = `/zwy/api/cb/logistics/rent/order/stock/batch/month/export?projectId=${projectId}&balanceMonth=${balanceMonth}`;
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
  /* 导入 */
  static postUploadStorageRegisterExcel(data) {
    const url = "/zwy/api/cb/logistics/rent/order/stock/batch/month/import";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }


  // 编辑某月存储费总额
  static postModMonthStorageAmount(data, id) {
    const url = `/zwy/api/cb/logistics/rent/order/monthly/rent/${id}/update/charge`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  // 编辑记录
  static postStorageModRecordsList(id) {
    const url = `/zwy/api/cb/logistics/rent/order/monthly/rent/${id}/edit/records`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default StorageRegister